{
  "search": "Recherche",
  "tabs": {
    "users": "Utilisateurs",
    "roles": "Rôles",
    "roleProfiles": "Profils de rôles",
    "organizations": "Organisations",
    "clientReportTemplates": "Modèles de rapports clients",
    "featureFlags": "Indicateurs de fonctionnalités",
    "workflows": "Flux de travail",
    "downtimeSchedule": "Calendrier des temps d'arrêt",
    "pageConfigurations": "Configurations des pages",
    "staticPageWidgetConfigurations": "Configurations des widgets de page fixe",
    "htmlTemplates": "Modèles HTML modifiables",
    "notificationGroups": "Groupes de notification",
    "notificationDefinitions": "Définitions des notifications",
    "customFields": "Champs personnalisés",
    "localizationSettings": "Paramètres de localisation",
    "repCodes": "Codes représentants",
    "dashboards": "Tableaux de bord",
    "documentManagement": "Gestion des documents"
  },
  "userTable": {
    "name": "Nom",
    "email": "Courriel",
    "role": "Rôle",
    "displayRole": "Rôle d'affichage",
    "displayRoleFilterAll": "Tous les rôles d'affichage",
    "noResults": "Aucun utilisateur ne correspond à vos filtres",
    "accessType": "Type d'accès",
    "organization": "Organisation",
    "status": {
      "header": "Dernière connexion à",
      "LOGGED_IN": "Connecté(e)",
      "NOT_LOGGED_IN": "Non connecté(e)",
      "INVITED": "Invité(e)",
      "INVITATION_EXPIRED": "L'invitation a expiré",
      "NOT_INVITED": "Non invité"
    },
    "inviteUsersButton": "Inviter des utilisateurs",
    "userSearch": "Recherche"
  },
  "userEntityTable": {
    "title": "Entités liées",
    "name": "Nom",
    "relation": "Relation",
    "entityType": "Type d'entité"
  },
  "userRepCodeEntityTable": {
    "title": "Entités liées (codes représentants)",
    "name": "Nom",
    "repCodes": "Codes représentants"
  },
  "roleTable": {
    "name": "Nom",
    "navigationStyle": "Style de navigation",
    "noPermissions": "# Autorisations",
    "organization": "Organisation"
  },
  "roleProfilesTable": {
    "name": "Nom",
    "organization": "Organisation",
    "inherited": "Hérité"
  },
  "organizationTable": {
    "name": "Nom",
    "subdomain": "Sous-domaine",
    "parent": "Parent",
    "countriesJurisdictions": "Pays/Juridictions"
  },
  "workflowStates": {
    "DRAFT": "Brouillon",
    "ACTIVE": "Actif",
    "ARCHIVED": "Archivé"
  },
  "workflowTransitions": {
    "activate": "Définir le flux de travail comme actif",
    "draft": "Définir le flux de travail comme brouillon",
    "archive": "Définir le flux de travail comme archivé"
  },
  "workflowTransitionSuccess": "Changement de l'état du flux de travail",
  "workflowTable": {
    "name": "Nom",
    "state": "État",
    "numberOfSteps": "# d'étapes",
    "organization": "Organisation"
  },
  "workflowModal": {
    "title": "Créer un nouveau flux de travail",
    "name": "Nom"
  },
  "userModal": {
    "editTitle": "Mise à jour de l'utilisateur",
    "title": "Créer un nouvel utilisateur",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "email": "Courriel (utilisé pour la connexion)",
    "language": "Langue",
    "phoneUsedForLogin": "Téléphone (utilisé pour la connexion)",
    "phone": "Téléphone (utilisé pour la connexion)",
    "role": "Rôle",
    "avatar": "Avatar",
    "organization": "Organisation",
    "accessType": "Type d'accès",
    "resetMfa": "Réinitialiser l'authentification multifactorielle",
    "autoInviteUser": "Inviter automatiquement l'utilisateur",
    "inviteUser": "Inviter l'utilisateur",
    "resendInvitation": "Renvoyer l'invitation",
    "revokeInvitation": "Révoquer l'invitation",
    "repCodes": "Codes représentants",
    "repCodesNone": "Aucun code représentant",
    "viewFullClientGroup": "Voir le groupe de clients complet",
    "displayRole": "Rôle d'affichage",
    "displayRoleNone": "Aucun"
  },
  "accessUsers": {
    "title": "Accéder aux utilisateurs",
    "firstName": "Prénom",
    "lastName": "Nom de famille",
    "email": "Courriel",
    "loginStatus": "Statut de connexion",
    "lastLoginAt": "Dernière connexion à",
    "organization": "Organisation"
  },
  "userDeleteModal": {
    "deleteUser": "Supprimer un utilisateur",
    "deletedCompletely": "L'utilisateur sera complètement retiré de OneHub. Il ne pourra plus se connecter.",
    "wantToProceed": "Voulez-vous continuer?",
    "yesDelete": "Oui, supprimer"
  },
  "userRevokeInvitationModal": {
    "title": "Révoquer l'invitation de l'utilisateur",
    "body": "L'invitation existante sera révoquée. Vous pourrez à nouveau inviter l'utilisateur. Voulez-vous continuer?"
  },
  "userResetMultifactorModal": {
    "title": "Réinitialiser l'authentification multifacteur de l'utilisateur",
    "body": "L'utilisateur devra s'inscrire à l'authentification multifactorielle lors de sa prochaine connexion. Voulez-vous continuer ?"
  },
  "inviteSingleUserConfirmationModal": {
    "title": "Inviter un utilisateur",
    "body": "{{name}} recevra une invitation sur cette adresse courriel ({{email}}). Voulez-vous continuer?"
  },
  "inviteUsersConfirmationModal": {
    "title": "Inviter tous les utilisateurs en attente",
    "body": "Un total de {{total}} utilisateur(s) recevra une invitation par courriel. Voulez-vous continuer?"
  },
  "emailUpdateConfirmation": {
    "title": "Mise à jour de l'authentification des utilisateurs",
    "body": "L'utilisateur devra utiliser le nouvel courriel lors de sa prochaine connexion ({{email}}). Voulez-vous continuer?"
  },
  "roleModal": {
    "editTitle": "Mise à jour du rôle",
    "title": "Créer un nouveau rôle",
    "name": "Nom",
    "description": "Description",
    "organization": "Organisation",
    "roleProfile": "Profil de rôle",
    "permissions": "Autorisations",
    "accessiblePages": "Pages",
    "dashboards": "Tableaux de bord",
    "configurableTablePages": "Pages de tableaux configurables",
    "externalRoleId": "ID de rôle externe",
    "defaultAccessType": "Type d'accès par défaut",
    "nonIndividualPageConfiguration": "Configuration des pages non individuelles",
    "individualPageConfiguration": "Configuration des pages individuelles",
    "goalPageConfiguration": "Configuration de la page d'objectif",
    "accountPageConfiguration": "Configuration de la page du compte",
    "accountGroupPageConfiguration": "Configuration de la page du groupe de comptes",
    "householdPageConfiguration": "Configuration de la page ménage",
    "homePageConfiguration": "Configuration de la page d'accueil",
    "makeHouseholdDefaultView": "Définir la vue par défaut du ménage",
    "subAccountPageConfiguration": "Configuration de la page du sous-compte",
    "individualTableStaticPageWidgetConfiguration": "Configuration des widgets de page fixe : tableau individuel",
    "nonIndividualTableStaticPageWidgetConfiguration": "Configuration des widgets de page fixe : tableau non individuel",
    "householdTableStaticPageWidgetConfiguration": "Configuration des widgets de page fixe : tableau du ménage",
    "accountGroupTableStaticPageWidgetConfiguration": "Configuration des widgets de page fixe : tableau du groupe de comptes",
    "permissionsTable": {
      "read": "lire",
      "write": "écrire",
      "transition": "transition"
    },
    "formTemplateWarning": "Cette autorisation ne doit être accordée qu'aux utilisateurs internes",
    "undefinedDefaultAuthenticationConnection": "Utiliser la valeur par défaut de l'organisation"
  },
  "roleProfileModal": {
    "editTitle": "Mise à jour du profil de rôle",
    "title": "Créer un nouveau profil de rôle",
    "name": "Nom",
    "description": "Description",
    "organization": "Organisation",
    "permissions": "Permissions par défaut",
    "setAllPermitions": "Définir toutes les autorisations",
    "accessiblePages": "Pages",
    "dashboards": "Tableaux de bord",
    "configurableTablePages": "Pages de tableaux configurables",
    "permissionsTable": {
      "read": "lire",
      "write": "écrire",
      "transition": "transition"
    }
  },
  "roleProfileConfirmationModal": {
    "title": "Voulez-vous vraiment mettre à jour le profil du rôle?",
    "body": "Vous avez modifié le profil d'un rôle. Voulez-vous confirmer ces modifications?",
    "checkbox": "Mettez à jour tous les rôles associés avec ces modifications. Cette action annulera toutes les modifications apportées au(x) rôle(s) {{roles}}."
  },
  "roleDeleteModal": {
    "deleteRole": "Supprimer un rôle",
    "deletedCompletely": "Le rôle sera complètement supprimé de OneHub.",
    "wantToProceed": "Voulez-vous continuer?",
    "yesDelete": "Oui, supprimer le rôle"
  },
  "roleProfileArchiveModal": {
    "archiveRoleProfile": "Archiver le profil du rôle",
    "archiveConfirmation": "Le profil du rôle sera archivé et ne sera plus disponible sur OneHub.",
    "wantToProceed": "Voulez-vous continuer?",
    "yesArchive": "Oui, archiver le profil du rôle"
  },
  "newOrganizationModal": {
    "title": "Créer une nouvelle organisation"
  },
  "dashboardsTable": {
    "name": "Nom",
    "organization": "Organisation",
    "state": "État",
    "archive": "Archiver",
    "modelName": "Tableau de bord",
    "widgets": "Composants"
  },
  "organizationDetails": {
    "saveChanges": "Sauvegarder les modifications",
    "basics": "Les bases",
    "inheritance": "Héritage",
    "name": "Nom",
    "entityName": "Nom de l'entité",
    "entityNameHelperText": "Le nom qui apparaîtra sur les documents officiels tels que les formulaires de désignation de bénéficiaire",
    "subdomain": "Sous-domaine",
    "faviconLink": "Lien vers la favicon",
    "browserTabTitle": "Titre de l'onglet de navigateur",
    "parent": "Parent",
    "useParentFormTemplates": "Utiliser des modèles de formulaires parents",
    "useParentProductShelf": "Utiliser l'étagère du produit parent",
    "useParentModelPortfolios": "Utiliser des portfolios modèles pour les parents",
    "useParentAssetClasses": "Utiliser les classes d'actifs parents",
    "useParentThemes": "Utiliser les thèmes parents",
    "useParentSchedules": "Utiliser les horaires parents",
    "useParentFeeTiers": "Utiliser les grilles tarifaires des parents",
    "useParentWorkflows": "Utiliser les flux de travail des parents",
    "useParentRoleProfiles": "Utiliser des portfolios modèles pour les parents",
    "useParentPageConfigurations": "Utiliser les configurations de la page parent",
    "useParentStaticPageWidgetConfigurations": "Utiliser les configurations des widgets de page fixe parentes",
    "useParentCustodianConnections": "Utiliser les connexions parents-dépositaires",
    "useParentCustomFields": "Utiliser les champs personnalisés parents",
    "useParentBillingSchedules": "Utiliser les calendriers de facturation parents",
    "useParentIntegrations": "Utiliser les intégrations parents",
    "useParentWebhooks": "Utiliser les webhooks parents",
    "useParentLocalizations": "Utiliser les localisations parentes",
    "useParentThemeTokens": "Utiliser les jetons des thèmes parents",
    "useParentArticles": "Utiliser les articles d'actualité et de statistiques parents",
    "reviewTransactions": "Révision des transactions",
    "allowInstantInvest": "Permettre l'investissement instantané",
    "logo": "URL du logo",
    "topBarColor": "Couleur de la barre du haut",
    "topBarTextColor": "Couleur du texte de la barre du haut",
    "primaryColor": "Couleur primaire",
    "pageBackgroundColor": "Couleur d'arrière-plan de la page",
    "allowInactiveUserRebalancing": "Permettre le rééquilibrage des utilisateurs inactifs",
    "allowInactiveUserFeeCalculation": "Permettre le calcul du droit d'utilisation inactif",
    "allowInactiveUserAdjustments": "Activer les ajustements pour les utilisateurs gelés",
    "allowLogout": "Autoriser les déconnexions",
    "logoutRedirectUrl": "URL de redirection vers la déconnexion",
    "customRedirectUrlHelperText": "Avant de mettre à jour ce champ, vérifiez qu'il a été mis à jour dans auth0",
    "enableInactivityTimeOut": "Activer le délai d'inactivité",
    "inactivityTimeoutInMinutes": "Délai d'inactivité en minutes",
    "allowPortfolioPerGoal": "Permettre de définir un portefeuille par objectif",
    "requireManualAccountApproval": "Approbation manuelle des comptes",
    "requireSubTradeRequestApproval": "Vérification de l'opération requise",
    "allowViewSubTradeRequestPairs": "Autoriser à voir les paires des demandes de sous-opération",
    "allowPendingTransactions": "Inclure les transactions en attente dans les avoirs",
    "chargeAdminFeesToClient": "Facturer des frais administratifs au client",
    "uploadLogo": "Télécharger le logo",
    "uploadErrorPageBackgroundImage": "Arrière-plan de la page d'erreur d'importation",
    "displayNavbar": "Afficher la barre de navigation",
    "theme": "Thème",
    "accountTypeTaxRanking": "Type de compte Classement fiscal",
    "supportUrl": "URL de l'assistance",
    "helpCentreUrl": "URL du centre d'aide",
    "termsAndConditionsUrl": "URL des conditions générales",
    "customUrl": "URL personnalisée",
    "customUrlHelperText": "Avant de mettre à jour ce champ, vérifiez que le CNAME a bien été défini par l'équipe CloudOps",
    "urlError": "Url invalide",
    "colorError": "Code hexadécimal de couleur invalide",
    "logoUrlError": "Seul le format PNG est valide pour le logo.",
    "requireFeeApproval": "Approbation manuelle de frais",
    "hideAutoUpdatePrices": "Masquer les prix des mises à jour automatiques",
    "minimumInitialDeposit": "Dépôt initial minimum",
    "minimumInitialDeposit1Dollar": "Le dépôt initial minimum est de 1,00 $",
    "defaultTradingProcess": "Processus de transaction par défaut par sous-compte",
    "bulkTradingProcess": "Processus par défaut pour les opérations groupées",
    "blockSuspiciousTransactions": "Bloquer les transactions suspectes",
    "cashOnHoldToTradeDays": "Temps d'attente pour les échanges",
    "cashOnHoldToWithdrawDays": "Délai d'attente pour le retrait",
    "holdTimeRange": "Le délai d'attente doit être compris entre 0 et 365 jours",
    "defaultSignUpRole": "Rôle d'inscription par défaut",
    "defaultAdvisorRole": "Rôle du conseiller par défaut",
    "defaultClientRole": "Rôle du client par défaut",
    "authenticationTitle": "Options d'authentification",
    "disableStatsUpdateBasedOnTransactions": "Désactiver la mise à jour des statistiques en fonction des transactions",
    "disableRebalanceReport": "Désactiver le calcul des rapports de rééquilibrage",
    "minRecurringDepositCents": "Dépôt récurrent minimum",
    "minRecurringDepositError": "Le montant est inférieur au dépôt minimum acceptable.",
    "profileReviewTimeInMonths": "Durée d'examen du profil en mois",
    "profileReviewTimeInMonthsError": "La durée d'examen du profil en mois doit être supérieure à 0",
    "authenticationTheme": {
      "logo": "URL du logo (flux d'authentification)",
      "primaryColor": "Couleur primaire (flux d'authentification)",
      "pageBackgroundColor": "Couleur de fond de la page (flux d'authentification)"
    },
    "auth0DisplayName": "Afficher le nom (processus d'authentification)",
    "enableMultiFactorAuthentication": "Activer l'authentification multifactorielle",
    "multiFactorAuthenticationTitle": "Options d'authentification multifactorielle",
    "multiFactorAuthenticationOptions": {
      "EMAIL": "Courriel",
      "SMS": "SMS",
      "AUTHENTICATOR": "Authentifiant"
    },
    "enableRemeberBrowser": "Activer \"Se souvenir du navigateur\"",
    "enableEmailFrenchTranslation": "Activer la traduction des courriels en français",
    "defaultAuthenticationConnectionTitle": "Type d'authentification",
    "defaultAuthenticationConnectionOptions": {
      "EMAIL_AND_PASSWORD": "Courriel et mot de passe",
      "EMAIL_OTP": "Courriel - Code unique (sans mot de passe)",
      "ENTERPRISE": "Authentification unique de l'entreprise"
    },
    "allowAccessToSubOrganizations": "Autoriser l'accès aux sous-organisations",
    "authenticationDomainsTable": "Domaines d'authentification",
    "authenticationDomain": {
      "url": "URL",
      "authenticationType": "Type",
      "enterpriseConnectionName": "Nom de connexion",
      "useHostedLogin": "Connexion hébergée",
      "editTitle": "Mettre à jour le domaine d'authentification",
      "addTitle": "Ajouter un domaine d'authentification",
      "removeDomain": "Supprimer le domaine",
      "urlAlreadyExistsError": "L'URL existe déjà pour cette organisation",
      "logoutUrl": "URL de déconnexion"
    },
    "repCode": "Code représentatif",
    "displayMenuBar": "Afficher la barre du menu",
    "displayCurrency": "Afficher la devise",
    "allowPostOptimizationEditing": "Autoriser la modification après optimisation des demandes de sous-opération initiées",
    "autoInviteImportedUsers": "Inviter automatiquement les utilisateurs importés",
    "localization": "Localisation",
    "noLocalization": "aucun (valeurs par défaut appliquées)",
    "country": "pays",
    "currency": "devise",
    "enabledJurisdictions": "Territoire activé",
    "jurisdictionsIn": "Territoire : {{country}}",
    "jurisdictionsHelperText": "Choisissez au moins un territoire d'action pour cette organisation",
    "allJurisdictions": "tout",
    "selectedJurisdictions": "sélectionné",
    "jurisdictionsDisabledMessage": "Pour sélectionner des territoires, choisissez d'abord une localisation (ci-dessus) qui définit le ou les pays",
    "taxIdDetails": "Détails d'identification fiscale",
    "clientType": "Type de client",
    "formatting": "Formatage",
    "notImplemented": "Non implémenté",
    "minAmountDeposit": "Dépôt minimum",
    "minAmountDepositError": "Le montant est inférieur au dépôt minimum acceptable.",
    "errorPage": "Page d'erreur",
    "errorMessage": "Message d'erreur",
    "errorDescription": "Description de l'erreur",
    "errorButtonText": "Texte du bouton",
    "productShelfCurrencies": "Devises prises en charge pour l'étagère de produits",
    "enableContactSupport": "Activer la communication avec l'assistance",
    "enableResourcesAndArticles": "Activer les ressources et articles",
    "enableFullCashTransfers": "Activer les virements entièrement en espèces",
    "enablePartialCashTransfers": "Activer les virements partiellement en espèces",
    "enableAllInKindTransfers": "Activer les transferts tout en nature",
    "baseCurrency": "Devise de base",
    "transferTitle": "Virements",
    "cancelTransferCutoffDays": "Jours avant un virement où un virement ne peut plus être annulé"
  },
  "featureFlags": {
    "groups": {
      "ACCOUNT_TYPES": "Types de comptes",
      "ACCOUNT_TYPES_USA": "Types de comptes aux États-Unis",
      "ACCOUNT_TYPES_UK": "Types de comptes au Royaume-Uni",
      "TRADING": "Négociation",
      "TRANSFERS": "Virements",
      "ACCOUNT_MANAGEMENT": "Gestion des comptes",
      "PROFILE": "Profil",
      "DOCUMENTS_AND_STATEMENTS": "Documents et relevés",
      "TEMPORARY_FLAGS": "Indicateurs temporaires"
    },
    "table": {
      "featureFlags": "Indicateurs de fonctionnalités",
      "status": "Statut",
      "orgSettings": "Paramètres de l'organisation"
    },
    "status": {
      "enabled": "Activé",
      "disabled": "Désactivé"
    },
    "settings": {
      "on": "ACTIF",
      "off": "ARRÊT",
      "undefined": "HÉRITÉ"
    },
    "saveButton": "Mettre à jour",
    "updatedToastMessage": "Les indicateurs de fonctionnalités ont été mis à jour.",
    "tooltip": {
      "status": "État général compte tenu des paramètres hérités.",
      "orgSettings": "Paramètres définis pour cette organisation.\nHÉRITÉ - l'organisation parente la plus proche avec une valeur spécifiée (ACTIF ou ARRÊT) définira l'état de l'indicateur de fonctionnalité."
    }
  },
  "deleteLogoModal": {
    "title": "Supprimer le logo",
    "subtitle": "Êtes-vous sûr de vouloir supprimer ce logo de votre tableau de bord",
    "yesDelete": "Oui, Supprimer",
    "cancel": "Annuler"
  },
  "deleteErrorPageImageModal": {
    "title": "Supprimer l'image en arrière-plan",
    "subtitle": "Voulez-vous vraiment supprimer cette image de votre tableau de bord?",
    "yesDelete": "Oui, supprimer",
    "cancel": "Annuler"
  },
  "editableTemplate": {
    "title": "Modèles HTML modifiables",
    "templateName": "Nom du modèle",
    "placeholder": "Entrez le nom du modèle ici",
    "saveTemplate": "Sauvegarder le modèle HTML"
  },
  "pageConfigurationTable": {
    "name": "Nom",
    "type": "Type",
    "organization": "Organisation"
  },
  "staticPageWidgetConfigurationTable": {
    "add": "Ajouter",
    "name": "Nom",
    "widgetType": "Type de widget",
    "organization": "Organisation"
  },
  "customFieldTable": {
    "fieldLabel": "Étiquette du champ",
    "additionalInformation": "Renseignements complémentaires",
    "inputFormat": "Format d'entrée",
    "assiciateTo": "Objet associé à",
    "tranlatable": "Traduisible",
    "organization": "Organisation",
    "key": "Clé"
  },
  "repCodeTable": {
    "code": "Code",
    "name": "Nom",
    "organization": "Organisation",
    "inherited": "Inherited",
    "assignedUsers": "Utilisateurs assignés",
    "noAssignedUsers": "Aucun utilisateur assigné",
    "notDesignated": "Non désigné"
  },
  "repCodeModal": {
    "title": "Créer un code représentant",
    "editTitle": "Modifier le code représentant",
    "archiveTitle": "Archiver le code représentant?",
    "archiveBody": "Le code représentant sera complètement retiré. Voulez-vous continuer?",
    "code": "Code",
    "codeHelp": "Doit uniquement contenir des majuscules, des chiffres et des traits de soulignement",
    "name": "Nom",
    "modelName": "code représentant"
  },
  "pageConfigurationModal": {
    "title": "Créer une nouvelle configuration de page",
    "name": "Nom",
    "type": "Type",
    "types": {
      "INDIVIDUAL": "Individu",
      "NON_INDIVIDUAL": "Non-individuel",
      "ACCOUNT": "Compte",
      "GOAL": "Objectif",
      "SUB_ACCOUNT": "Sous-compte",
      "HOUSEHOLD": "Ménage",
      "ACCOUNT_GROUP": "Account Group"
    }
  },
  "staticPageWidgetConfigurationModal": {
    "title": "Créer une nouvelle configuration de widget de page fixe",
    "name": "Nom",
    "type": "Type",
    "create": "Créer",
    "types": {
      "INDIVIDUAL_TABLE": "Tableau individuel",
      "NON_INDIVIDUAL_TABLE": "Tableau non individuel",
      "HOUSEHOLD_TABLE": "Tableau du ménage",
      "ACCOUNT_GROUP_TABLE": "Tableau du groupe de comptes"
    }
  },
  "editCustomFieldDialog": {
    "title": "Archiver le champ personnalisé?",
    "body": "Le champ personnalisé sera complètement retiré. Voulez-vous continuer?"
  },
  "customFieldModal": {
    "title": "Créer un champ personnalisé",
    "enableConditionalRules": "Ajouter des règles conditionnelles",
    "editTitle": "Modifier le champ personnalisé",
    "keyHelp": "Doit uniquement contenir des minuscules, des chiffres et des traits de soulignement",
    "nameHelp": "Caractères non autorisés: < > \\ | ^ * ` ~",
    "descriptionHelp": "Caractères non autorisés: < > \\ | ^ * ` ~",
    "selectOptionsHelp": "Caractères non autorisés: < > \\ | ^ * ` ~",
    "keyPlaceholder": "boolean_field_10001",
    "key": "Clé",
    "type": "Type",
    "format": "Format",
    "displayText": "Texte d'affichage",
    "value": "Ajouter des options à la section (séparer chaque option avec un saut de ligne)",
    "descriptionMsg": "Le texte ci-dessus figurera dans une fenêtre modale lorsque l'utilisateur cliquera dessus ",
    "formats": {
      "CHECKBOX": "Case à cocher",
      "CURRENCY": "Devise",
      "DATE": "Date",
      "DATE_TIME": "Date et heure",
      "DROPDOWN_LIST": "Liste déroulante",
      "EMAIL": "Courriel",
      "NUMBER": "Numéro",
      "PHONE": "Téléphone",
      "PHYSICAL_ADDRESS": "Adresse physique",
      "CUSTOM_AGREEMENTS": "Accords sur mesure",
      "BANK_ACCOUNT": "Compte bancaire",
      "RADIO_BUTTON": "Bouton radio",
      "SEARCH_LIST": "Liste de recherche",
      "SIMPLE_TEXT": "Texte simple",
      "TEXT_AREA": "Zone de texte",
      "TOGGLE_SWITCH": "Commutateur",
      "CUSTOM": "Personnalisé"
    },
    "types": {
      "BOOLEAN": "Booléen",
      "CUSTOM_OBJECT": "Objet personnalisé",
      "DATE": "Date",
      "DECIMAL": "Décimale",
      "INTEGER": "Nombre entier",
      "MULTIPLE_SELECT": "Sélection multuple",
      "SINGLE_SELECT": "Sélection unique",
      "TEXT": "Texte"
    },
    "objectType": "Objet associé à",
    "objectTypes": {
      "ACCOUNT": "Compte",
      "ENTITY": "Entité",
      "GOAL": "Objectif",
      "HOUSEHOLD": "Ménage",
      "SUB_ACCOUNT": "Sous-compte",
      "TRANSACTION": "Transaction",
      "HOLDING": "Détention",
      "ACCOUNT_GROUP": "Groupe de comptes"
    },
    "translatedDescription": "Renseignements complémentaires",
    "translatedName": "Étiquette du champ",
    "workflowStep": "Étape du flux de travail",
    "workflowOptions": {
      "APPROVAL": "Approbation",
      "DOCUMENTS": "Documents",
      "EDIT_ACCOUNT": "Modifier le compte",
      "EDIT_GOAL": "Modifier l'objectif",
      "EMPLOYMENT_INFORMATION": "Situation professionnelle",
      "HOUSEHOLD": "Ménage",
      "NON_INDIVIDUAL_INFORMATION": "Renseignements non individuels",
      "PERSONAL_INFORMATION": "Renseignements personnels",
      "PERSONS_OF_INTEREST": "Personnes d'intérêt",
      "RELATIONSHIP_INFORMATION": "Renseignements sur les relations",
      "RESIDENCY_INFORMATION": "Renseignements sur la résidence",
      "INCOME_ASSETS_AND_DEBTS": "Revenus, actifs et dettes"
    },
    "customFieldSource": "Source",
    "source": {
      "CUSTODIAN": "Dépositaire",
      "INTERNAL": "OneVest"
    },
    "enablePositiveNegativeSign": "Activer le signe positif/négatif",
    "enableAggregation": "Activer l'agrégation",
    "customFormatHelp": "Veuillez contacter les intégrations OneVest pour configurer une intégration au format personnalisé."
  },
  "downtimeScheduleTable": {
    "add": "Ajouter",
    "name": "Nom",
    "state": "État",
    "status": "Statut",
    "organization": "Organisation"
  },
  "downtimeScheduleState": {
    "ACTIVE": "Actif",
    "ARCHIVED": "Archivé",
    "INACTIVE": "Inactif"
  },
  "downtimeScheduleStatus": {
    "UPCOMING": "À venir",
    "ONGOING": "En cours",
    "COMPLETED": "Terminé"
  },
  "downtimeSchedulePlatform": {
    "ANDROID": "Android",
    "IOS": "IOS",
    "WEB": "Web"
  },
  "downtimeScheduleModal": {
    "title": "Gérer le calendrier des temps d'arrêt",
    "name": "Nom",
    "note": "Note",
    "platforms": "Plateformes",
    "startTime": "Heure de début",
    "endTime": "Heure de fin",
    "excludeRoles": "Exclure des rôles",
    "helpLink": "Lien d'aide",
    "state": "État",
    "organization": "Organisation",
    "downtimeScheduleDescription": "Description",
    "downtimeScheduleTitle": "Titre",
    "create": "Créer",
    "edit": "Mettre à jour",
    "futureDateError": "L'heure de début doit être dans le futur",
    "platformsRequired": "Au moins une plateforme doit être sélectionnée"
  },
  "notificationDefinitionTable": {
    "name": "Nom",
    "object": "Objet",
    "notificationGroup": "Groupe de notification",
    "roleProfiles": "Profils de rôles",
    "organization": "Organisation",
    "event": "Événement",
    "triggerObjectType": {
      "Account": "Compte",
      "Goal": "Objectif",
      "SubAccount": "Sous-compte",
      "Transfer": "Virement",
      "User": "Utilisateur",
      "ScheduledTransfer": "Virement programmé",
      "AccountStatement": "Relevé de compte"
    },
    "triggerEventType": {
      "RECONCILED": "Rapproché",
      "CREATED": "Créé",
      "CHECK_ACCOUNT_MARKET_VALUE": "Valeur marchande du compte chèque",
      "AWAITING_REVIEW": "Examen en attente",
      "SIGNED": "Signé",
      "RESIGNED": "À nouveau signé",
      "CANCELED": "Annulé",
      "COMPLETED": "Terminé",
      "REQUESTED": "Demandé",
      "REVIEWING": "Examen en cours",
      "PROCESSING": "Traitement en cours",
      "INITIATED": "Initié",
      "READY": "Prêt",
      "FAILED": "Échec",
      "PERSONAL_ACCOUNT_INFORMATION_UPDATED": "Renseignements du compte personnel mis à jour",
      "FROZEN": "Gelé",
      "PERSONAL_INFORMATION_UPDATED": "Renseignements personnels mis à jour",
      "LOGIN_CREDENTIALS_UPDATED": "Identifiants de connexion mis à jour",
      "USER_ID_CHECK_UPDATED": "Vérification de l'identifiant d'utilisateur mise à jour",
      "SUITABILITY_SCORE_UPDATED": "Score d'adéquation mis à jour",
      "SUITABILITY_REVIEW_DUE_COMPLETE_11_MONTHS_AGO": "Examen d'adéquation proche de l'échéance",
      "SUITABILITY_REVIEW_DUE_COMPLETE_13_MONTHS_AGO": "Examen d'adéquation à échéance",
      "SUITABILITY_REVIEW_OVERDUE": "Examen d'adéquation en retard",
      "ACTIVE": "Actif",
      "INACTIVE": "Inactif",
      "INVITATION_EMAIL_SENT": "Courriel d'invitation envoyé"
    },
    "workflow": "Flux de travail",
    "add": "Ajouter"
  },
  "notificationDefinitionModal": {
    "title": "Définitions des notifications",
    "name": "Nom",
    "notificationGroup": "Groupe de notification",
    "titleTemplate": "Modèle de titre",
    "bodyTemplate": "Modèle de corps",
    "linkTemplate": "Modèle de lien",
    "linkText": "Texte du lien",
    "roleProfiles": "Profils de rôles",
    "triggerObjectType": {
      "title": "Objet déclencheur",
      "Account": "Compte",
      "Goal": "Objectif",
      "SubAccount": "Sous-compte",
      "Transfer": "Virement",
      "User": "Utilisateur",
      "ScheduledTransfer": "Virement programmé",
      "AccountStatement": "Relevé de compte"
    },
    "triggerEventType": {
      "title": "Événement déclencheur",
      "RECONCILED": "Rapproché",
      "CREATED": "Créé",
      "CHECK_ACCOUNT_MARKET_VALUE": "Valeur marchande du compte chèque",
      "AWAITING_REVIEW": "Examen en attente",
      "SIGNED": "Signé",
      "RESIGNED": "À nouveau signé",
      "CANCELED": "Annulé",
      "COMPLETED": "Terminé",
      "REQUESTED": "Demandé",
      "REVIEWING": "Examen en cours",
      "PROCESSING": "Traitement en cours",
      "INITIATED": "Initié",
      "READY": "Prêt",
      "FAILED": "Échec",
      "FROZEN": "Gelé",
      "PERSONAL_INFORMATION_UPDATED": "Renseignements personnels mis à jour",
      "PERSONAL_ACCOUNT_INFORMATION_UPDATED": "Renseignements du compte personnel mis à jour",
      "LOGIN_CREDENTIALS_UPDATED": "Identifiants de connexion mis à jour",
      "USER_ID_CHECK_UPDATED": "Vérification de l'identifiant d'utilisateur mise à jour",
      "SUITABILITY_SCORE_UPDATED": "Score d'adéquation mis à jour",
      "SUITABILITY_REVIEW_DUE_COMPLETE_11_MONTHS_AGO": "Examen d'adéquation proche de l'échéance",
      "SUITABILITY_REVIEW_DUE_COMPLETE_13_MONTHS_AGO": "Examen d'adéquation à échéance",
      "SUITABILITY_REVIEW_OVERDUE": "Examen d'adéquation en retard",
      "ACTIVE": "Actif",
      "INACTIVE": "Inactif"
    },
    "create": "Créer",
    "edit": "Mettre à jour",
    "remove": "Retirer"
  },
  "notificationGroupTable": {
    "name": "Nom",
    "object": "Objet",
    "notificationGroup": "Groupe de notification",
    "organization": "Organisation"
  },
  "notificationGroupModal": {
    "title": "Créer un nouveau groupe de notification",
    "name": "Nom",
    "description": "Description",
    "remove": "Retirer"
  },
  "editNotificationGroupModal": {
    "title": "Modifier le groupe de notification",
    "name": "Nom"
  },
  "notificationChannelsOptions": {
    "enableTypes": {
      "EMAIL": "Activer les notifications par courriel",
      "IN_APP": "Activer les notifications dans l'application",
      "PUSH": "Activer les notifications poussées",
      "WEBHOOK": "Activer les notifications avec lien de rappel"
    },
    "setDefaultState": "Définir l'état par défaut",
    "allowEditByClient": "Autoriser les modifications par le client"
  },
  "clientReportTemplates": {
    "new": "Nouveau modèle",
    "frequency": "Fréquence",
    "frequencies": {
      "WEEKLY": "Hebdomadaire",
      "MONTHLY": "Mensuel",
      "QUARTERLY": "Trimestriel",
      "YEARLY": "Annuel",
      "ONE_TIME": "Unique"
    },
    "association": "Association",
    "associations": {
      "USER": "Client",
      "ACCOUNT": "Compte",
      "ACCOUNT_GROUP": "Groupe de comptes",
      "GOAL": "Objectif",
      "SUB_ACCOUNT": "Sous-compte",
      "CLIENT_GROUP": "Groupe de clients",
      "INDIVIDUAL": "Individuel",
      "NON_INDIVIDUAL": "Non individuel"
    },
    "states": {
      "DRAFT": "Brouillon",
      "ACTIVE": "Actif",
      "INACTIVE": "Inactif"
    },
    "lastGenerationDate": "Date de la dernière génération"
  },
  "localizationSettings": {
    "countries": "Pays",
    "defaultCurrency": "Devise de base",
    "languages": "Langue(s)",
    "default": "défaut",
    "dateFormat": "Format de la date",
    "deleteConfirmationModal": {
      "title": "Voulez-vous supprimer cette localisation?",
      "confirm": "Supprimer",
      "cancel": "Annuler"
    }
  },
  "documentManagement": {
    "name": "Nom",
    "association": "Association",
    "lastUpdatedAt": "Dernière mise à jour",
    "minVersion": "Version",
    "state": "État",
    "type": "Type",
    "view": "Voir",
    "edit": "Modifier",
    "draft": "Brouillon",
    "activate": "Activer",
    "archive": "Archiver",
    "editDraft": "Modifier le brouillon",
    "history": "Historique",
    "associatedTo": "Associé à",
    "searchByName": "Rechercher par nom",
    "ACCOUNT": "Compte",
    "SUB_ACCOUNT": "Sous-compte",
    "SCHEDULE_TRANSFER": "Programmer un virement",
    "USER": "Utilisateur",
    "GOAL": "Objectif",
    "CLIENT_GROUP": "Groupe de clients",
    "NotAssigned": "Non attribué",
    "minVersionLable": "Version min. :",
    "template": "Modèle de document",
    "templateState": {
      "DRAFT": "Brouillon",
      "ACTIVE": "Actif",
      "ARCHIVED": "Archivé"
    },
    "noTitle": "Aucun titre défini",
    "action": {
      "edit": "Modifier",
      "publish": "Publier",
      "preview": "Aperçu",
      "draft": "Enregistrer le brouillon",
      "download": "Télécharger/Imprimer",
      "apply": "Appliquer"
    },
    "toastMessage": {
      "success": "Le modèle de formulaire a été correctement mis à jour"
    },
    "objectType": {
      "ACCOUNT": "compte",
      "SUB_ACCOUNT": "sous-compte",
      "SCHEDULE_TRANSFER": "programmer un virement",
      "USER": "utilisateur",
      "GOAL": "objectif",
      "CLIENT_GROUP": "groupe de clients"
    },
    "previewObject": {
      "selectUser": "Clients",
      "selectGoal": "Objectifs",
      "selectAccount": "Comptes",
      "selectSubAccount": "Sous-comptes",
      "selectScheduleTransfer": "Programmer les virements",
      "selectClientGroup": "Groupes de clients",
      "selectTitle": "Sélectionnez un(e) {{objectType}} à prévisualiser"
    }
  },
  "localizationModal": {
    "createTitle": "Créer une localisation",
    "editTitle": "Modifier la localisation",
    "name": "Nom",
    "nameHelper": "Nom lisible des paramètres de localisation ci-dessous",
    "countries": "Pays applicable(s)",
    "countriesHelper": "Un ou plusieurs pays où les clients d'une organisation sont servis",
    "defaultCurrency": "Devise de base",
    "defaultCurrencyHelper": "Devise (de base) par défaut utilisée dans les rapports",
    "languages": "Langue(s) de l'IU",
    "defaultLanguage": "Langue par défaut",
    "dateFormat": "Format de la date",
    "dateFormatHelper1": "Suivre : ",
    "dateFormatHelper2": "chaîne de formatage des jours",
    "datePreview": "Aperçu de la date",
    "firstDay": "1er jour de ce mois",
    "today": "aujourd'hui",
    "lastDay": "dernier jour de ce mois",
    "phoneNumberCountryCodes": "Indicatifs téléphoniques par pays",
    "phoneNumberCountryCodesHelper": "Lorsque la liste des codes pays est vide, les pays applicables seront utilisés par défaut",
    "languageChangeWarning": "Les modifications des paramètres de langue s'appliqueront à tous les utilisateurs."
  },
  "changeOrganization": "Changer d'organisation",
  "ORGANIZATION": "Accès organisationnel",
  "REP_CODE": "Code d’accès représentant",
  "ENTITY": "Accès des entités",
  "exchangeRatesConfiguration": {
    "title": "Configuration des taux de change",
    "manualUpdate": "Mise à jour manuelle",
    "autoUpdate": "Mise à jour automatique",
    "fromTo": "{{from}} à {{to}}",
    "rateError": "Le taux doit être supérieur à 0"
  },
  "bulkTradingProcessOptions": {
    "pair": "PAIRE",
    "bucket": "BUCKET"
  },
  "configurableTablePages": {
    "archiveConfigurableTablePageModal": {
      "title": "Archiver {{configurableTablePageName}}?",
      "bodyText": "Cette page de tableau configurable sera archivée. Voulez-vous continuer?"
    },
    "title": "Pages de tableau configurables",
    "inheritFromParent": "Hériter des pages de tableau configurable de l'organisation parente",
    "description": "Les pages de tableau configurable permettent de créer des tableaux personnalisés pour afficher les données de votre organisation. Vous pouvez configurer les filtres, colonnes et la pagination selon vos besoins.",
    "table": {
      "name": "Nom",
      "sectionName": "Nom de la section",
      "organization": "Organisation"
    },
    "noData": "Aucune page de tableau configurable trouvée",
    "errorLoading": "Erreur lors du chargement de la page de tableau configurable",
    "createSuccess": "Page de tableau configurable créée avec succès",
    "updateSuccess": "Page de tableau configurable mise à jour avec succès",
    "requiredFiltersMessage": "Veuillez définir les filtres requis pour afficher les données : {{filtersNames}}",
    "noSearchResults": "Aucun résultat ne correspond aux critères de recherche",
    "searchResultsWillAppearHere": "Les résultats de recherche s'afficheront ici",
    "errorLoadingData": "Erreur lors du chargement des données",
    "loading": "Chargement...",
    "export": {
      "title": "Exporter les données",
      "generating": "Génération du fichier d'export...",
      "completed": "Export terminé avec succès",
      "failed": "Échec de l'export",
      "download": "Télécharger"
    },
    "searchFilters": {
      "title": "OPTIONS DE RECHERCHE",
      "search": "Rechercher",
      "reset": "Réinitialiser"
    },
    "modal": {
      "title": "Créer une page de tableau configurable",
      "editTitle": "Modifier la page de tableau configurable",
      "settings": {
        "title": "Paramètres",
        "name": "Nom",
        "sectionName": "Nom de la section",
        "sectionIcon": "Icône de section",
        "navigateToPath": "Chemin de navigation",
        "navigateToPathNone": "Aucun",
        "navigateToPathKey": "Clé du chemin de navigation",
        "endpointUrl": "URL du point de terminaison",
        "paginationType": "Type de pagination",
        "enableDownload": "Activer le téléchargement",
        "useTopSearchPanel": "Utiliser le panneau de recherche en haut",
        "navigateToPathError": "Le chemin de navigation est requis lorsque la clé du chemin est fournie",
        "navigateToPathKeyError": "La clé du chemin de navigation est requise lorsque le chemin est fourni",
        "enableCustomPagination": "Personnaliser les options de pagination",
        "customPageSizes": "Options de taille de page (séparées par des virgules)",
        "customPageSizesError": "Les options de taille de page sont requises lorsque la personnalisation de la pagination est activée",
        "customPageSizesPlaceholder": "ex. 10, 25, 50, 100"
      },
      "filters": {
        "title": "Filtres",
        "filterOptions": "Options de filtre",
        "name": "Nom",
        "key": "Clé",
        "type": "Type",
        "format": "Format",
        "required": "Requis",
        "isTopLevelFilter": "Filtre de premier niveau",
        "additionalInfo": "Informations complémentaires",
        "default": "Par défaut",
        "types": {
          "TEXT": "Texte",
          "SINGLE_SELECT": "Sélection unique",
          "MULTIPLE_SELECT": "Sélection multiple",
          "DATE": "Date",
          "BOOLEAN": "Booléen",
          "INTEGER": "Entier",
          "DECIMAL": "Décimal"
        },
        "formats": {
          "TOGGLE_SWITCH": "Interrupteur",
          "CHECKBOX": "Case à cocher",
          "RADIO_BUTTON": "Bouton radio",
          "DROPDOWN_LIST": "Liste déroulante",
          "NUMBER": "Nombre",
          "CURRENCY": "Devise",
          "DATE": "Date",
          "DATE_TIME": "Date et heure",
          "SIMPLE_TEXT": "Texte simple"
        },
        "options": {
          "title": "Options",
          "optionsType": "Type d'options",
          "staticOptions": "Options statiques",
          "optionsUrl": "URL des options"
        },
        "staticOptionsKey": "Clé",
        "staticOptionsLabel": "Libellé",
        "addStaticOption": "Ajouter une option statique",
        "addFilter": "Ajouter un filtre",
        "updateFilter": "Modifier le filtre"
      },
      "columns": {
        "title": "Colonnes",
        "columnOptions": "Options de colonne",
        "name": "Nom",
        "key": "Clé",
        "type": "Type",
        "formatter": "Formateur",
        "badgeColorKey": "Clé de couleur du badge",
        "additionalInfo": "Informations complémentaires",
        "sortable": "Triable",
        "types": {
          "DATE": "Date",
          "TEXT": "Texte",
          "CURRENCY": "Devise",
          "NUMBER": "Nombre",
          "BADGE": "Badge",
          "PERCENTAGE": "Pourcentage"
        },
        "formatters": {
          "SIMPLE_TEXT": "Texte simple",
          "TRANSLATED_TEXT": "Texte traduit",
          "CAPITALIZED_TEXT": "Texte en majuscules",
          "DATE": "Date",
          "DATE_TIME": "Date et heure",
          "MULTIPLY_BY_100": "Multiplier par 100",
          "DIVIDE_BY_100": "Diviser par 100"
        },
        "addColumn": "Ajouter une colonne",
        "updateColumn": "Modifier la colonne",
        "badgeMapping": {
          "title": "Mappage des badges",
          "value": "Valeur",
          "color": "Couleur",
          "addMapping": "Ajouter un mappage"
        },
        "includeInTotals": "Inclure dans les totaux",
        "rowScope": "Portée de la ligne",
        "rowScopes": {
          "MAIN": "Principale",
          "COLLAPSIBLE": "Réductible"
        }
      },
      "widgets": {
        "addWidget": "Ajouter un widget",
        "updateWidget": "Mettre à jour le widget",
        "widgetType": "Type de widget",
        "options": "Options",
        "types": {
          "FREE_FORM_INPUT": "HTML de forme libre"
        },
        "title": "Composants"
      }
    },
    "paths": {
      "ACCOUNTS": "Comptes",
      "INDIVIDUALS": "Particuliers",
      "NON_INDIVIDUALS": "Non-particuliers",
      "HOUSEHOLDS": "Ménages",
      "GOALS": "Objectifs",
      "SUB_ACCOUNTS": "Sous-comptes",
      "ACCOUNT_GROUPS": "Groupes de comptes"
    },
    "paginationType": {
      "OFFSET": "Décalage",
      "CURSOR": "Curseur"
    },
    "total": "Total",
    "noDataAvailable": "Aucun enregistrement n'est disponible à afficher",
    "editor": {
      "preview": "Aperçu",
      "saveToSearch": "Enregistrez vos modifications pour rechercher et charger les données de prévisualisation."
    },
    "expandRow": "Développer la ligne",
    "collapseRow": "Réduire la ligne"
  },
  "permissionLabels": {
    "themes": "model_family(themes)",
    "drift_settings": "Paramètres de dérive"
  },
  "update": "Mettre à jour",
  "a11y": {
    "moreActions": "Plus d'actions"
  },
  "dashboardArchiveModal": {
    "title": "Archiver le tableau de bord?",
    "body": "Ce tableau de bord sera archivé et n'apparaîtra plus dans les listes de tableaux de bord actifs.",
    "confirm": "Archiver"
  },
  "successArchiveDashboard": "Tableau de bord archivé avec succès"
}
